/** Shared text UI constants (La Tostadora–style). */

export const EDITOR_FONTS = [
  { family: 'Acme, sans-serif', label: 'Acme' },
  { family: 'Bangers, cursive', label: 'Bangers' },
  { family: 'Anton, sans-serif', label: 'Anton' },
  { family: 'Oswald, sans-serif', label: 'Oswald' },
  { family: 'Pacifico, cursive', label: 'Pacifico' },
  { family: 'Rubik, sans-serif', label: 'Rubik' },
  { family: 'Bebas Neue, sans-serif', label: 'Bebas Neue' },
  { family: 'Arial, sans-serif', label: 'Arial' },
  { family: '"Arial Black", Gadget, sans-serif', label: 'Arial Black' },
  { family: 'Impact, Haettenschweiler, sans-serif', label: 'Impact' },
  { family: 'Georgia, serif', label: 'Georgia' },
  { family: '"Courier New", monospace', label: 'Courier New' },
  { family: 'Verdana, sans-serif', label: 'Verdana' },
  { family: '"Comic Sans MS", cursive', label: 'Comic Sans' },
  { family: '"Times New Roman", Times, serif', label: 'Times' },
] as const;

export const TEXT_SWATCHES = [
  { hex: '#111111', label: 'Negro' },
  { hex: '#4b5563', label: 'Gris oscuro' },
  { hex: '#9ca3af', label: 'Gris claro' },
  { hex: '#ffffff', label: 'Blanco' },
  { hex: '#dc2626', label: 'Rojo' },
  { hex: '#ec4899', label: 'Rosa' },
  { hex: '#7c3aed', label: 'Morado' },
  { hex: '#4f46e5', label: 'Índigo' },
  { hex: '#0f766e', label: 'Verde azulado' },
  { hex: '#06b6d4', label: 'Cian' },
  { hex: '#0ea5e9', label: 'Azul cielo' },
  { hex: '#1e3a8a', label: 'Azul marino' },
  { hex: '#166534', label: 'Verde' },
  { hex: '#84cc16', label: 'Lima' },
  { hex: '#eab308', label: 'Amarillo' },
  { hex: '#fb923c', label: 'Naranja claro' },
  { hex: '#ea580c', label: 'Naranja' },
] as const;

export function swatchLabel(hex: string): string {
  const found = TEXT_SWATCHES.find((s) => s.hex.toLowerCase() === hex.toLowerCase());
  return found?.label ?? hex;
}
